const riot = require('riot');

riot.tag2('page-settings', '<div class="f s-full"> <div class="box-shadow" if="{!app.useragent.isMobile}" ref="sidebar" data-is="module-sidebar"></div> <div class="f fclm s-full p32 s-p12"> <div class="f fclm s-full bg-white p32 rounded-4 box-shadow overflow-y-scroll"> <div class="mb32" data-is="module-title-header" title="マイページ"> <yield to="right"> <button class="button high fs12 fw4" type="button" onclick="{parent.signOut}">ログアウト</button> </yield> </div> <div class="s-full s-mb24"> <div class="container-372 w-full"> <form onsubmit="{onSubmit}"> <div class="mb80"> <div class="s80 circle object-fit-cover overflow-hidden mb52 mxa" ref="image" data-is="atom-input-image" riot-src="{user.data.icon_url}"></div> <label> <div class="lh15 text-label_high mb8">ユーザー名</div> <input class="input large w-full lh15 text-label_high mb32" ref="display_name" type="text" placeholder="名前を入力してください" required> </label> <label> <div class="lh15 text-label_high mb8"><span class="mr4">ユーザーID</span><span class="fs10">※半角英数字3文字以上、-と_のみ使用可能</span></div> <input class="input large w-full lh15 text-label_high mb32" ref="screen_name" type="text" pattern="{app.data.input.validation.screen_name}" placeholder="idを入力してください" required> </label> </div> <div class="f fh"> <button class="button primary px34 py7 lh15 fs12 fw4">更新</button> </div> </form> </div> </div> </div> <div if="{app.useragent.isMobile}" data-is="module-tabbar"></div> </div> </div>', 'page-settings,[data-is="page-settings"]{display:block}', '', function(opts) {
    this.preload = async () => {
      if (spat.isNode) return;

      var user = await app.utils.auth.fetchCurrentUser();

      return {
        user
      };
    };

    this.on('show', () => {
      this.refs.screen_name.value = this.user.data.screen_name;
      this.refs.display_name.value = this.user.data.display_name;

    });

    this.onSubmit = async (e) => {
      e.preventDefault();

      var data = {
        screen_name: this.refs.screen_name.value,
        display_name: this.refs.display_name.value,
      };

      var url = await this.refs.image.uploadAndGetImageURL();
      if (url) {
        data.icon_url = url;
      }

      await this.user.update(data);
      spat.toast.message('保存しました!');
    };

    this.signOut = async () => {
      var result = await spat.modal.confirm('ログアウトしますか?');
      if (!result) return;
      app.auth.signOut();
      spat.router.push('/signin');
    };
});